import Collapsable from '../lib/Collapsable';

const state = {
  accordions: {},
  elements: {},
  searchParams: new URLSearchParams(window.location.search),
  staticParamKeys: ['sort_by', 'filter.v.availability', 'q', 'type', 'options%5Bprefix%5D', 'options%5Bunavailable_products%5D']
};

const cacheState = () => {
  const sectionWrapper = document.getElementById(`section-wrapper-${window.Collection.section.id}`)
  if (!sectionWrapper) return null;
  const sortContainer = sectionWrapper.querySelector('.filters__sortBtn')
  state.elements = {
    ...state.elements,
    collectionsContainer: sectionWrapper.querySelector('.collections'),
    sortBtn: sectionWrapper.querySelector('.sort-btn'),
    sortOptions: sortContainer.querySelectorAll('.filters__sort-option'),
    sortBackdrop: sectionWrapper.querySelector('.filters__sort-backdrop'),
    filterBtn: sectionWrapper.querySelector('.filters__filterBtn'),
    filterDrawer: sectionWrapper.querySelector('.filters.filters__drawer'),
    filtersDrawerBackdrop: sectionWrapper.querySelector('.filters__drawer-backdrop'),
    emptyFilterClear: sectionWrapper.querySelector('#empty-filters--clear'),
    filtersOptionItems: sectionWrapper.querySelectorAll('.filters__option-item'),
    filterClearBtn: sectionWrapper.querySelector('.filters__drawer-clear'),
    filterApplyBtn: sectionWrapper.querySelector('.filters__drawer-apply'),
    filterCloseBtn: sectionWrapper.querySelector('.filters__drawer-closeBtn'),
    selectedFiltersContainer: sectionWrapper.querySelector('.filters__selected'),
    sortContainer,
  };
  state.searchParams.set('sort_by', sortContainer?.dataset?.value);
  state.searchParams.set('filter.v.availability', 1);
  state.actionsRouter = {
    clear: onClearFilters,
    item: (e) => {
      const selectedItemEl = e.target.closest('div[data-value]');
      if (!selectedItemEl) return;

      const { value } = selectedItemEl.dataset;
      const filterEl = document.querySelector(`.filters__option-item[data-value="${value}"]`);

      if (!filterEl) return;

      selectedItemEl.remove();
      onFilterSelect({ target: filterEl })
    }
  }
};

const addEventListener = () => {
  // Sort Event Listeners
  state.elements.sortBtn.addEventListener('click', toggleSortDropdown);
  state.elements.sortBackdrop.addEventListener('click', (e) => toggleSortDropdown(e, 'remove'));
  state.elements.sortOptions.forEach(option => option.addEventListener('click', onSortOptionSelect));
  // Filter Event Listeners
  state.elements.filterBtn.addEventListener('click', toggleFilterDrawer);
  state.elements.filtersDrawerBackdrop.addEventListener('click', (e) => toggleFilterDrawer(e, 'remove'));
  state.elements.emptyFilterClear.addEventListener('click', onClearFilters);
  state.elements.filterClearBtn.addEventListener('click', onClearFilters);
  state.elements.filterCloseBtn.addEventListener('click', (e) => toggleFilterDrawer(e, 'remove'));
  state.elements.filterApplyBtn.addEventListener('click', (e) => toggleFilterDrawer(e, 'remove'));
  state.elements.filtersOptionItems.forEach(option => option.addEventListener('click', onFilterSelect));
  state.elements.selectedFiltersContainer.addEventListener('click', onSelectedFilterClick)
  // Others
  document.addEventListener('product-grid:filters:loaded', updateFilterValuesStatus)
};

const init = () => {
  if (!window.Collection?.section?.id) return
  cacheState();
  addEventListener();
  initFiltersDrawerCollapsables()
};

// Filters

const initFiltersDrawerCollapsables = () => {
  const filterWrappers = document.querySelectorAll('.filters__item--wrapper');
  filterWrappers.forEach(wrapper => {
    const item = wrapper.querySelector('.filters__item')
    const filterParam = wrapper.dataset.filterParam
    state.accordions[filterParam] = new Collapsable({
      element: wrapper.querySelector('.filters__options-group'),
      toggler: wrapper.querySelector('.filters__item'),
      container: wrapper,
      openClass: 'active',
      onToggle: () => {
        Object.values(state.accordions).forEach((el) => {
          if (el.togglerEl !== item) {
            el.close();
          }
        });
      },
    });
  });
};

const toggleFilterDrawer = (e, action='toggle') => {
  window.dispatchEvent(new CustomEvent('update-css-vars'));

  const { sortContainer, collectionsContainer } = state.elements;
  if (sortContainer.classList.contains('active')) {
    toggleSortDropdown(null, 'remove');
  }
  collectionsContainer.classList[action]('active-filters');
  document.body.classList[action]('overflow-hidden');
};

const onFilterSelect = (e) => {
  if (e.target.classList.contains('disabled')) return;
  const { searchParams } = state;
  const filterKey = e.target.closest('.filters__item--wrapper').dataset.filterParam;
  const filterValue = e.target.dataset.value;
  const appliedFilterValues = searchParams.getAll(filterKey);
  if (appliedFilterValues.includes(filterValue)) {
    searchParams.delete(filterKey);
    appliedFilterValues.forEach(value => {
      if (value !== filterValue) {
        searchParams.append(filterKey, value);
      }
    });
    e.target.classList.remove('active');
  } else {
    e.target.classList.add('active');
    searchParams.append(filterKey, filterValue)
  }

  dispatchParamChangeEvent(true, searchParams.toString())
};

const onClearFilters = () => {
  const { staticParamKeys } = state;
  const { filtersOptionItems } = state.elements;
  const newSearchParams = new URLSearchParams();
  staticParamKeys.forEach(param => {
    const paramValues = state.searchParams.getAll(param);
    paramValues.forEach(value => {
      newSearchParams.append(param, value);
    });
  });

  filtersOptionItems.forEach(item => item.classList.remove('active'));
  toggleFilterDrawer(null, 'remove');
  

  dispatchParamChangeEvent(true, newSearchParams.toString(), true);
  state.searchParams = newSearchParams;
};

const onSelectedFilterClick = (e) => {
  e.preventDefault();
  const { selectedFiltersContainer } = state.elements;
  selectedFiltersContainer.classList.add('loading');

  const selectedItemEl = e.target.closest('div[data-type]')
  const type = selectedItemEl?.dataset.type;
  
  if (state.actionsRouter[type]) {
    state.actionsRouter[type](e);
  }
}

// Sort

const toggleSortDropdown = (e, action='toggle') => {
  const { collectionsContainer, sortContainer } = state.elements;
  if (collectionsContainer.classList.contains('active-filters')) {
    toggleFilterDrawer(null, 'remove');
  }
  sortContainer.classList[action]('active');
};

const onSortOptionSelect = (e) => {
  toggleSortDropdown(null, 'remove');
  const { searchParams, elements } = state;
  const sortValue = e.target.dataset.value;
  const sortLabel = e.target.textContent;
  if (searchParams.get('sort_by') === sortValue) return;
  elements.sortContainer.dataset.value = sortValue;
  searchParams.set('sort_by', sortValue);
  elements.sortBtn.textContent = `SORT BY: ${sortLabel}`;
  elements.sortOptions.forEach(option => option.classList.remove('active'))
  e.target.classList.add('active')

  dispatchParamChangeEvent(false, searchParams.toString());
};

const dispatchParamChangeEvent = (isFilterChanged=false, params, clear=false) => {
  document.dispatchEvent(new CustomEvent(
    'product-grid:param:change',
    {
      detail: {
        filtersChanged: isFilterChanged,
        params,
        clear,
      },
    }
  ));
};

const updateFilterValuesStatus = (e) => {
  const { filtersStatus } = e.detail;
  const { filtersOptionItems } = state.elements;
  filtersOptionItems.forEach(option => {
    const { key, handle } = option.dataset;
    const action = filtersStatus[key][handle] ? 'remove' : 'add';
    option.classList[action]('disabled');
  })
}

export default init;
